// extracted by mini-css-extract-plugin
module.exports = {"container":"_311QavN","footer":"_2hoqJYB","gameTitle":"LHgDTao","titleImage":"_2CSq6fQ","img":"s1KtM7W"};